import type { ValidationResult } from 'joi';
import { cloneDeep } from 'lodash';

import { SerializableObject } from '../../../generic/serialization/serializable-object';
import { SerializableObjectSchema } from '../../../generic/serialization/serializable-object-schema';
import { UserPresenceConnection } from '../user-presence-connection/user-presence-connection';
import { UserPresenceConnectionDeviceType } from '../user-presence-connection/user-presence-connection-device-type';

import { UserPresenceConstructor } from './user-presence-constructor';
import { UserPresenceSchema } from './user-presence-schema';

export class UserPresence extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected connections!: Map<string, UserPresenceConnection>;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: UserPresenceConstructor) {
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by SerializableObject.
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: ValidationResult): UserPresence {
    return new UserPresence(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(UserPresence.getSchema(), 'rtdb');
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new UserPresenceSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getConnections() {
    return cloneDeep(this.connections);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Other Methods
  /////////////////////////////////////////////////////////////////////////////

  public hasDesktopConnection(): boolean {
    for (const connection of this.connections.values()) {
      if (connection.getDeviceType() === UserPresenceConnectionDeviceType.desktop) {
        return true;
      }
    }

    return false;
  }
}
